import {
  GetCategoriesRootApiResponseData,
  GetCategoryApiResponseData,
} from 'core_main/api/categories/types';
import { CategoryCallbackResponse } from './types';

export const createRootCategoryCallbackResponse = (
  rootCategory: GetCategoriesRootApiResponseData,
): CategoryCallbackResponse => {
  const { attributes, id } = rootCategory;

  const { categoryPositions } = attributes;

  return {
    childCategories: categoryPositions,
    categoryId: id,
  };
};

export const createCategoryCallbackResponse = (
  category: GetCategoryApiResponseData,
): CategoryCallbackResponse => {
  const { attributes, id } = category;

  const {
    parent,
    categoryPositions: childCategories,
    title,
    description,
  } = attributes;

  return {
    categoryId: id,
    parentCategory: parent,
    childCategories,
    title,
    description,
  };
};
